export const AUTH_TOKEN = "articlex_auth_token";
